'use strict';

/* globals grecaptcha */

var processBalanceAjaxCall = function (ajaxUrl, giftCardType, giftCardNumber, giftCardPin, captcha, target) {
    var gcType;
    if (giftCardType === 'Physical') {
        gcType = 'card';
    } else if (giftCardType === 'Electronic') {
        gcType = 'electronic';
    }
    if (target) {
        let inModal = $(target).parents('.tingle-modal').length > 0;
        if (inModal) {
            captcha = $(target).parents('.tingle-modal').find('[name="g-recaptcha-response"]')[0].value;
        } else {
            captcha = $(target).parents('.gift-card-number').find('[name="g-recaptcha-response"]')[0].value;
        }
    } else {
        if (document.querySelector('#g-recaptcha-response') != null) {
            captcha = document.querySelector('#g-recaptcha-response').value;
        }
    }
    if (!captcha && captcha != null) {
        $('.no-robot').removeClass('hidden');
        $.spinner().stop();
        return;
    }

    $.ajax({
        url: ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
            giftCardType: giftCardType,
            giftCardNumber: giftCardNumber,
            giftCardPin: giftCardPin,
            captcha: captcha || ''
        },
        success: responseData => {
            $('.giftcard-checkbalance-error').addClass('hidden');
            $('.resocard-checkbalance-balance-error').addClass('hidden');
            $('.giftcard-checkbalance-balance-error').addClass('hidden');
            $('.giftcard-checkbalance-error-expired').addClass('hidden');
            $('.giftcard-checkbalance-success').addClass('hidden');
            $('.resocard-checkbalance-success').addClass('hidden');
            $('.resocard-checkbalance-error').addClass('hidden');
            $('.resocard-checkbalance-error-expired').addClass('hidden');
            $('.wrapper-content-slot').removeClass('hiddenGiftCard');
            $('body').trigger('einsteinGiftCardRecommendation');
            $('.js-giftcard-error-message').addClass('hidden');

            if (responseData.amount === 0) {
                $('.giftcard-checkbalance-success').addClass('hidden');
                $('.resocard-checkbalance-success').addClass('hidden');
                $('.giftcard-checkbalance-balance-error').removeClass('hidden');

                return;
            }

            if (!responseData.success) {
                if (responseData.message) {
                    $('.js-giftcard-error-message').text(responseData.message);
                    $('.js-giftcard-error-message').removeClass('hidden');
                } else if (responseData.isResocard) {
                    if (responseData.isExpired) {
                        // Display error expired reso card
                        $('.resocard-checkbalance-error-expired').removeClass('hidden');
                    } else {
                        $('.resocard-checkbalance-error').removeClass('hidden');
                    }
                } else {
                    if (responseData.isExpired) {
                        // Display error gift card expired
                        $('.giftcard-checkbalance-error-expired').removeClass('hidden');
                    } else {
                        // Display not enough balance error
                        $('.giftcard-checkbalance-error').removeClass('hidden');
                    }
                }
            } else {
                $('body').trigger('checkout:giftcardCheckBalance', { 'gcCode': giftCardNumber, 'gcType': gcType });
                // Display success message
                if (responseData.isResocard) {
                    $('.resocard-checkbalance-success').removeClass('hidden');
                    $('.resocard-checkbalance-balance').removeClass('hidden');
                    $('.resocard-checkbalance-balance').text(`${responseData.currency} ${responseData.amount}`);
                    $('.resocard-checkbalance-expired').text(`${responseData.expiryDate}`);
                    $('.js-check-balance').addClass('hidden');
                    $('.js-check-yourbalance-button').addClass('hidden');
                } else {
                    $('.giftcard-checkbalance-success').removeClass('hidden');
                    $('.giftcard-checkbalance-balance').removeClass('hidden');
                    $('.giftcard-checkbalance-balance').text(`${responseData.currency} ${responseData.amount}`);
                    $('.giftcard-checkbalance-expired').text(`${responseData.expiryDate}`);
                    $('.js-check-balance').addClass('hidden');
                    $('.js-check-yourbalance-button').addClass('hidden');
                }
                if (responseData.firstName) {
                    $('.js-giftcardNameToStamp').text('' + responseData.firstName);
                } else {
                    $('.js-giftcardNameToStamp').text('');
                }
            }
        },
        error: () => {
            // Display error with not enough balance
            $('.resocard-checkbalance-balance-error').addClass('hidden');
            $('.giftcard-checkbalance-balance-error').addClass('hidden');
            $('.resocard-checkbalance-success').addClass('hidden');
            $('.resocard-checkbalance-error').addClass('hidden');
            $('.resocard-checkbalance-error-expired').addClass('hidden');
            $('.giftcard-checkbalance-error').removeClass('hidden');
            $('.giftcard-checkbalance-error-expired').addClass('hidden');
            $('.giftcard-checkbalance-success').addClass('hidden');
            $('#giftCardPane input[type="text"]').removeClass('valid-data');
            $('.js-giftcard-error-message').addClass('hidden');
        },
        complete: () => {
            $.spinner().stop();
            try {
                grecaptcha.reset();
            } catch (e) {
                console.error(e);
            }
        }
    });
};

// Disabled CTA if inputs are empty
const checkGiftCardInputFields = () => {
    var isGiftCardCodeEmpty = !$('.input-code').val();
    var isGiftCardPinEmpty = $('.input-pin').is(':visible') && !$('.input-pin').val();
    $('.js-giftcard-check-balance').prop('disabled', isGiftCardCodeEmpty || isGiftCardPinEmpty);
};

const processBalance = () => {
    $('body').trigger('einsteinGiftCardRecommendation');
    $.spinner().start();
    var giftCardType = $('form#form-gift-card input[type="radio"]#card-fisica:checked').length > $('input[type="radio"]#e-card:checked').length ? 'Physical' : 'Electronic';
    var giftCardNumber = $('form#form-gift-card input[name="inputCode"]').val();
    var giftCardPin = $('form#form-gift-card input[name="inputPin"]').val();
    var captcha = document.querySelector('#g-recaptcha-response').value;
    processBalanceAjaxCall($('form#form-gift-card').data('url'), giftCardType, giftCardNumber, giftCardPin, captcha);
};

module.exports = {
    retriveGiftCardBalanceFooter: function () {
        $('body').on('change', '[id="card-fisica"]', () => {
            $('.wrapper-content-slot').addClass('hiddenGiftCard');
            $('.input-code').removeClass('is-invalid-input');
            $('#errorInputCode').addClass('hiddenErrorsGiftCard');
            $('.input-pin').removeClass('is-invalid-input');
            $('#errorInputPin').addClass('hiddenErrorsGiftCard');
            $('#e-card-label').removeClass('selected');
            $('#card-fisica-label').addClass('selected');
            grecaptcha.reset();
        });
        $('body').on('change', '[id="e-card"]', () => {
            $('.wrapper-content-slot').addClass('hiddenGiftCard');
            $('.input-code').removeClass('is-invalid-input');
            $('#errorInputCode').addClass('hiddenErrorsGiftCard');
            $('.input-pin').removeClass('is-invalid-input');
            $('#errorInputPin').addClass('hiddenErrorsGiftCard');
            grecaptcha.reset();
        });

        $('body').on('input', '.input-code', function (e) {
            e.preventDefault();
            $('.input-code').removeClass('is-invalid-input');
            $('#errorInputCode').removeClass('hiddenErrorsGiftCard');
        });

        $('body').on('input', '.input-pin', function (e) {
            e.preventDefault();
            $('.input-pin').removeClass('is-invalid-input');
            $('#errorInputPin').addClass('hiddenErrorsGiftCard');
        });

        // Disabled CTA if inputs are empty on input
        $('body').on('input', '.input-code, .input-pin', checkGiftCardInputFields);
        // Disabled CTA if inputs are empty on type switch
        $('body').on('change', '[name="input-radio-1"]', checkGiftCardInputFields);

        $('body').on('click', 'form#form-gift-card .button', function (e) {
            e.preventDefault();

            if ($('#card-fisica').is(':checked')) {
                if ($('.input-code').val() !== undefined && $('.input-code').val() !== '' && $('.input-pin').val() !== undefined && $('.input-pin').val() !== '') {
                    processBalance();
                } else {
                    if ($('.input-code').val() == undefined || $('.input-code').val() == '') {
                        $('#errorInputCode').removeClass('hiddenErrorsGiftCard');
                        $('.input-code').addClass('is-invalid-input');
                    }
                    if ($('.input-pin').val() == undefined || $('.input-pin').val() == '') {
                        $('#errorInputPin').removeClass('hiddenErrorsGiftCard');
                        $('.input-pin').addClass('is-invalid-input');
                    }
                    $('.wrapper-content-slot').addClass('hiddenGiftCard');
                }
            } else {
                if ($('.input-code').val() !== undefined && $('.input-code').val() !== '') {
                    processBalance();
                } else {
                    $('#errorInputCode').removeClass('hiddenErrorsGiftCard');
                    $('.input-code').addClass('is-invalid-input');
                    $('.wrapper-content-slot').addClass('hiddenGiftCard');
                }
            }
        });
    },
    retriveGiftCardBalance: function () {
        $('body').on('click', 'form.giftCardBalanceModalForm .js-check-balance', function () {
            var giftCardType = $('form.giftCardBalanceModalForm input[type="radio"]#giftCardPhysical:checked').length > $('input[type="radio"]#giftCardElectronic:checked').length ? 'Physical' : 'Electronic';
            var giftCardNumber = $('form.giftCardBalanceModalForm #giftCardNumber').val();
            var giftCardPin = $('form.giftCardBalanceModalForm #giftCardPin').val();
            $('#giftCardFormGroup #giftCardNumber').val(giftCardNumber);
            $('#giftCardFormGroup #giftCardPin').val(giftCardPin);
            if (giftCardType === 'Physical') {
                if ($('#giftCardPane input[type="radio"]#giftCardElectronic:checked').length) {
                    $('##giftCardPane input[type="radio"]#giftCardPhysical').trigger('click');
                }
            } else {
                if ($('#giftCardPane input[type="radio"]#giftCardPhysical:checked').length) {
                    $('#giftCardPane input[type="radio"]#giftCardElectronic').trigger('click');
                }
            }

            processBalanceAjaxCall($('form.giftCardBalanceModalForm').data('url'), giftCardType, giftCardNumber, giftCardPin, undefined, $(this));
        });
    },

    applyGiftcard: function () {
        $('body').on('click', '.apply-giftcard', function (e) {
            var captcha;
            let target = $(this);
            if (target) {
                let inModal = $(target).parents('.tingle-modal').length > 0;
                if (inModal) {
                    captcha = $(target).parents('.tingle-modal').find('[name="g-recaptcha-response"]')[0].value;
                } else {
                    captcha = $(target).parents('.gift-card-number').find('[name="g-recaptcha-response"]')[0].value;
                }
            } else {
                if (document.querySelector('#g-recaptcha-response') != null) {
                    captcha = document.querySelector('#g-recaptcha-response').value;
                }
            }

            if (!captcha && !$(e.target).hasClass('remove-applied-giftcard')) {
                $('.no-robot').removeClass('hidden');
                return;
            }
            var giftCardType = $('input[type="radio"]#giftCardPhysical:checked').length > $('input[type="radio"]#giftCardElectronic:checked').length ? 'Physical' : 'Electronic';
            var giftCardNumber = $('#giftCardNumber').val();
            var giftCardPin = $('#giftCardPin').val();

            $.ajax({
                url: $('#giftCardFormGroup').data('url'),
                method: 'POST',
                dataType: 'json',
                data: {
                    giftCardType: giftCardType,
                    giftCardNumber: giftCardNumber,
                    giftCardPin: giftCardPin
                },
                success: responseData => {
                    $('.giftcard-amount-feedback').removeClass('hidden');
                    $('.giftcard-amount-feedback').removeClass('error');
                    $('.gift-card-error').addClass('hidden');
                    if (!responseData.success) {
                        $('.giftcard-amount-feedback').addClass('error');
                        $('.gift-card-error').removeClass('hidden').text(responseData.message);
                        $('.giftcard-applied').addClass('hidden');
                        $('.giftCardRemainedAmount').addClass('hidden').text('');
                        $('.giftcard-applied').removeClass('multipaymentToSelect');
                    } else {
                        $('body').trigger('checkout:applyGiftCard', {'gcCode': giftCardNumber, 'gcType': giftCardType.toLowerCase()});
                        $('.giftcard-modal-block').addClass('hidden');
                        $('.gift-card-error').addClass('hidden');
                        $('.item-giftcard').removeClass('hidden');
                        $('.giftcard-total').text(responseData.amountText);
                        $('.giftcard-applied').removeClass('hidden').html(responseData.message);
                        $('#giftCardFormGroup .buttonApplyGiftcard').addClass('hide');
                        $('#giftCardFormGroup .buttonRemoveGiftcard').removeClass('hide');
                        $('.giftCardNumberField, .giftCardPinField').addClass('giftcardSubmitted');
                        $('.giftCardRemainedAmount').removeClass('hidden').html(responseData.messageRemainedAmount);
                        if (responseData.coversTotalAmount) {
                            $('#GIFT_CARD').click();
                            $('.drawer input[name$="paymentMethod"]:not(#GIFT_CARD, #RESO_CARD)').attr('disabled', true);
                            $('.giftCardDrawer .giftcard-submit-payment').removeClass('hidden');
                            $('.giftCardRemainedAmount').removeClass('giftcardMultiPaymentAmount');
                        } else {
                            $('.giftCardRemainedAmount').addClass('giftcardMultiPaymentAmount');
                            $('.js-express-button').removeClass('disableExpressButton');
                            $('.giftcard-applied').addClass('multipaymentToSelect');
                            if ($('input#DW_APPLE_PAY:checked').length > 0 && $('#apple-pay-btn').length > 0) {
                                $('.applepay-tab-header input').trigger('change');
                            }
                        }
                        // For multipayment
                        $('body').trigger('checkout:updateCheckoutView', {
                            order: responseData.order,
                            customer: responseData.customer,
                            coversTotalAmount: responseData.coversTotalAmount,
                            action: 'addGiftcard'
                        });
                        $('.tingle-modal .close').trigger('click');
                    }
                },
                error: () => {
                    $('.giftcard-modal-block').addClass('hidden');
                    $('.giftcard-amount-feedback').addClass('error');
                    $('.gift-card-error').removeClass('hidden');
                },
                complete: () => {
                    $.spinner().stop();
                    try {
                        grecaptcha.reset();
                        $('.no-robot').addClass('hidden');
                    } catch (e) {
                        console.error(e);
                    }
                }
            });
        });
    },

    getGiftCardBalance: function () {
        $('#giftCardPane .buttonApplyGiftcard').on('click', function (e) {
            var captcha;
            if (document.querySelector('#g-recaptcha-response') != null) {
                captcha = document.querySelector('#g-recaptcha-response').value;
            }
            if (!captcha && !$(e.target).hasClass('remove-applied-giftcard')) {
                $('.no-robot').removeClass('hidden');
                return;
            }
            var giftCardType = $('input[type="radio"]#giftCardPhysical:checked').length > $('input[type="radio"]#giftCardElectronic:checked').length ? 'Physical' : 'Electronic';
            var giftCardNumber = $('#giftCardNumber').val();
            var giftCardPin = $('#giftCardPin').val();

            var gcType;
            if (giftCardType === 'Physical') {
                gcType = 'card';
            } else if (giftCardType === 'Electronic') {
                gcType = 'electronic';
            }

            // Reset coupon section state
            $('.card.coupon-code, .loyalty-coupons-container').removeClass('disabled');
            $('.checkout-applied-giftcard-message').addClass('hide');

            $.ajax({
                url: $('#giftCardFormGroup').data('url'),
                method: 'POST',
                dataType: 'json',
                data: {
                    giftCardType: giftCardType,
                    giftCardNumber: giftCardNumber,
                    giftCardPin: giftCardPin
                },
                success: responseData => {
                    $('.giftcard-amount-feedback').removeClass('hidden');
                    $('.giftcard-amount-feedback').removeClass('error');
                    $('.gift-card-error').addClass('hidden');
                    $('#giftCardFormGroup .buttonRemoveGiftcard').removeClass('hide');
                    if (!responseData.success) {
                        if (responseData.message) {
                            $('.giftcard-amount-feedback').addClass('error');
                            $('.js-error-message').addClass('hidden');
                            $('.js-notFound-message').removeClass('hidden');
                            $('.gift-card-error .js-notFound-message').text(responseData.message);
                        } else {
                            $('.js-error-message').removeClass('hidden');
                            $('.js-notFound-message').addClass('hidden');
                            $('.giftcard-amount-feedback').addClass('error');
                            $('.gift-card-error').removeClass('hidden');
                            $('.giftcard-applied').addClass('hidden');
                            $('.giftCardRemainedAmount').addClass('hidden').text('');
                            $('.giftcard-applied').removeClass('multipaymentToSelect');
                        }
                    } else {
                        $('body').trigger('checkout:applyGiftCard', {'gcCode': giftCardNumber, 'gcType': gcType});
                        $('.giftcard-modal-block').addClass('hidden');
                        if (responseData.isResocard) {
                            $('.display-resocard').removeClass('hidden');
                        } else {
                            $('.display-giftcard').removeClass('hidden');
                        }
                        $('.gift-card-error').addClass('hidden');
                        $('.item-giftcard').removeClass('hidden');
                        $('.giftcard-applied').removeClass('hidden').html(responseData.message);
                        $('.giftcard-total').text(responseData.amountText);
                        $('#giftCardFormGroup .js-recaptcha').addClass('hide');
                        $('#giftCardFormGroup .js-controlCardButtons').addClass('hide');
                        $('.giftCardNumberField, .giftCardPinField').addClass('giftcardSubmitted');
                        if (giftCardType === 'Electronic') {
                            $('.green-check-mark').addClass('eCard');
                        } else if (giftCardType === 'Physical') {
                            $('.green-check-mark').addClass('physicalCard');
                        }

                        if (responseData.coversTotalAmount) {
                            $('#GIFT_CARD').click();
                            $('.drawer input[name$="paymentMethod"]:not(#GIFT_CARD, #RESO_CARD)').attr('disabled', true);
                            $('.giftCardDrawer .giftcard-submit-payment').removeClass('hidden');
                            $('.giftCardRemainedAmount').removeClass('giftcardMultiPaymentAmount');
                        } else {
                            $('.giftCardRemainedAmount').addClass('giftcardMultiPaymentAmount');
                            $('.js-express-button').removeClass('disableExpressButton');
                            $('.giftcard-applied').addClass('multipaymentToSelect');
                            if ($('input#DW_APPLE_PAY:checked').length > 0 && $('#apple-pay-btn').length > 0) {
                                $('.applepay-tab-header input').trigger('change');
                            }
                        }
                        $('.giftCardRemainedAmount').removeClass('hidden').html(responseData.messageRemainedAmount);

                        // Disable coupon application (code and loyalty) when EGC is applied
                        $('.card.coupon-code, .loyalty-coupons-container').addClass('disabled');
                        $('.checkout-applied-giftcard-message').removeClass('hide');

                        // For multipayment
                        $('body').trigger('checkout:updateCheckoutView', {
                            order: responseData.order,
                            customer: responseData.customer,
                            coversTotalAmount: responseData.coversTotalAmount,
                            action: 'addGiftcard'
                        });
                    }
                },
                error: () => {
                    $('.giftcard-modal-block').addClass('hidden');
                    $('.gift-card-error').removeClass('hidden');
                    $('.giftcard-amount-feedback').addClass('error');
                    $('.js-giftcard-error-message').addClass('hidden');
                },
                complete: () => {
                    $.spinner().stop();
                    try {
                        grecaptcha.reset();
                        $('.no-robot').addClass('hidden');
                    } catch (e) {
                        console.error(e);
                    }
                }
            });
        });
    },

    handleGiftcardInput: function () {
        $('body').on('input', '#giftCardFormGroup .giftCardNumberField,#giftCardFormGroup .giftCardPinField', function (e) {
            $('.giftcard-amount-feedback').addClass('hidden');
            $('.giftcard-amount-feedback').removeClass('error');
            $('.gift-card-error').addClass('hidden');
        });
    },
    checkingGiftCardType: function () {
        $('.gift-card-number').addClass('physicalCard');
        $('#giftCardPhysical').on('click', function () {
            $('.gift-card-number').addClass('physicalCard');
            $('.gift-card-number').removeClass('eCard');
        });
        $('#giftCardElectronic').on('click', function () {
            $('.gift-card-number').addClass('eCard');
            $('.gift-card-number').removeClass('physicalCard');
        });
    }
};
